import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { LearningPathFormPage } from '@/features/learning-path/pages/LearningPathFormPage';
import { requireAccess } from '@/permissions';

export const Route = createFileRoute('/trilha-de-aprendizagem/nova')({
  staticData: { title: 'Criar trilha de aprendizagem' },
  beforeLoad: requireAccess('create:learning_path'),
  component: NovaLearningPathRoute,
});

function NovaLearningPathRoute(): JSX.Element {
  return <LearningPathFormPage mode='create' />;
}
